import { useMemo } from 'react';
import { useGate } from 'effector-react';
import { Dropdown, type DropdownItem } from '@components/Dropdown';
import { LibDateTypeGate } from '../stores/libState';

const items: DropdownItem[] = [
  { id: 0, name: '最新修改' },
  { id: 1, name: '最新创建' },
  { id: 2, name: '名称正序' },
  { id: 3, name: '名称倒序' },
];

const itemsNoName: DropdownItem[] = [
  { id: 0, name: '最新修改' },
  { id: 2, name: '最新创建' },
];

interface SortSelectorProps {
  className?: string;
  noNameSort?: boolean;
  value: number;
  onChange: (id: number) => void;
}

export function SortSelector({
  className,
  noNameSort,
  value,
  onChange,
}: SortSelectorProps) {
  const dateType = useMemo(() => {
    if (noNameSort && value === 2) {
      return 'createDate';
    }
    if (!noNameSort && value === 1) {
      return 'createDate';
    }
    return 'updateDate';
  }, [noNameSort, value]);

  useGate(LibDateTypeGate, dateType);
  return (
    <Dropdown
      items={noNameSort ? itemsNoName : items}
      className={className}
      selected={value}
      onChange={onChange}
      getTitleName={(name) => `排序：${name}`}
      scheme="light"
    />
  );
}

export default SortSelector;
